import { setDevice } from './redux/actions';

export const setDeviceType = (store) => {
  window.addEventListener('resize', function() {
    store.dispatch(setDevice(window.innerWidth))
  })
  
  //on load, set device type
  store.dispatch(setDevice(window.innerWidth))
}







// WEBPACK FOOTER //
// ./src/features/common/PageDeviceType.js